<template>
  <v-text-field :id="searchBarId" append-icon="search" :placeholder="placeholder" :hint="hint" :value="searchValue" @input="searchInput"/>
</template>

<script>
  import debounce from 'lodash.debounce'

  export default {
    name: 'search-bar',
    props: {
      placeholder: {},
      hint: {},
      searchAction: {
        type: String,
        required: true
      },
      debounceTime: {
        type: Number,
        default: 300
      },
      searchValue: {
        type: String,
        required: true
      },
      searchBar: {
        type: String,
        required: true
      }
    },
    data () {
      return {}
    },
    methods: {},
    computed: {
      searchInput () {
        return debounce((searchString) => {
          this.$store.dispatch(this.searchAction, searchString)
        }, this.debounceTime)
      },
      searchBarId () {
        return `search-bar-text-${this.searchBar}`
      }
    },
    watch: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/student/SearchBar.vue